import useForm from "../../../shared/forms/useForm";
import Form from "../../../shared/forms/Form";
import FormCalendarRange from "../../../shared/forms/FormFields/FormCalendarRange";
import { Dialog } from "primereact/dialog";
import Field from "../../../shared/forms/Field";
import moment from "moment";
import { Button } from "primereact/button";
import React from "react";
import useApiFlotillas from "../../../api/comercial/useApiFlotillas";
import FieldMultiSelect from "../../../shared/forms/FormFields/FormMultiSelect";

const ExportarFlotillas = ({ visible, onCancel, unidades }) => {
  const api = useApiFlotillas();
  const { values, onChange, onValidate } = useForm({
    fechas: [moment().startOf("day").add(-7, "day").toDate(), new Date()],
    unidadIds: [],
  });

  const onExport = async () => {
    const fechas = values.fechas || [];
    const fechaInicio = moment(fechas[0]).format("YYYY-MM-DD");
    const fechaFin = moment(fechas[1]).format("YYYY-MM-DD");
    let seleccionadas = values.unidadIds;
    if (!seleccionadas?.length) {
      seleccionadas = unidades?.map((u) => u.id) ?? [];
    }
    const payload = {
      UnidadIds: seleccionadas.join(","),
      Fechas: [fechaInicio, fechaFin],
      GeocercaIds: (values.geocercaIds || []).join(","),
    };
    await api.excelFlotillaGeocerca(payload);
  };

  const renderFooter = () => (
    <div>
      <Button
        label="Exportar"
        icon="pi pi-check"
        onClick={onExport}
        autoFocus
      />
    </div>
  );

  return (
    <Dialog
      header="Exportar Flotilla"
      visible={visible}
      style={{ width: "850px" }}
      onHide={onCancel}
      footer={renderFooter()}
    >
      <Form
        columns={12}
        values={values}
        onChange={onChange}
        onValidate={onValidate}
      >
        <Field
          label="Rango de Fechas"
          field="fechas"
          cols={6}
          render={FormCalendarRange}
        />

        <Field
          field="unidadIds"
          label="Unidades"
          cols={6}
          render={({ onParentChange, parent, ...props }) => (
            <FieldMultiSelect
              {...props}
              source="unidades"
              params={{ todasLasEmpresas: true }}
              placeholder="Selecciona unidades"
              onChange={(ids) => onParentChange({ unidadIds: ids })}
            />
          )}
        />

        <Field
          field="geocercaIds"
          label="Geocercas"
          cols={12}
          render={({ onParentChange, parent, ...props }) => (
            <FieldMultiSelect
              {...props}
              source="geocercas"
              mapItem={(e) => ({
                label: e.nombre,
                value: e.id,
              })}
              placeholder="Selecciona geocercas"
              onChange={(ids) => onParentChange({ geocercaIds: ids })}
            />
          )}
        />
      </Form>
    </Dialog>
  );
};

export default ExportarFlotillas;
